(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var selector = [
    '.site-header',
    '.ht-cart-header',
    '.high-tide-header',
    '.about-header',
    '.contact-header',
    '.hero h1', '.hero h2', '.hero p', '.hero .btn', '.hero img',
    'main section h1', 'main section h2', 'main section h3', 'main section h4',
    'main section p',
    'main section img:not(.green-bg):not(.about-real-bg)',
    'main section a.button', 'main section .button', 'main section button',
    'main section .product-card', 'main section .card', 'main section .values-grid > *',
    'main section .real-banner', 'main section .green-feature',
    'main section .vegan-badge', 'main section .warning-badge',
    'main section .ab-seal', 'main section .ab-warning',
    'main section .ct-card', 'main section .ct-item', 'main section .ct-locator',
    'main section .cart-item', 'main section .cart__footer', 'main section .totals',
    'main section .sl-widget-host', 'main section .ht-mapmigo-locator-wrap',
    '.site-footer h2', '.site-footer h3', '.site-footer p', '.site-footer a', '.site-footer li', '.site-footer .footer-col',
    '.ht-cart-footer h2', '.ht-cart-footer h3', '.ht-cart-footer p', '.ht-cart-footer a', '.ht-cart-footer li', '.ht-cart-footer .footer-col'
  ].join(',');

  function isVisibleTarget(el) {
    if (!el || el.classList.contains('ht-reveal') || el.closest('.cart-notification')) return false;
    if (el.closest('script, style, noscript, template')) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function revealDirection(el) {
    if (el.matches('img, .product-card, .card, .ct-card, .cart-item, .sl-widget-host')) return 'ht-reveal-zoom';
    var section = el.closest('section, footer, header');
    if (!section) return '';
    var all = Array.prototype.slice.call(section.querySelectorAll(selector)).filter(isVisibleTarget);
    var index = all.indexOf(el);
    if (index % 3 === 1) return 'ht-reveal-left';
    if (index % 3 === 2) return 'ht-reveal-right';
    return '';
  }

  function initReveal() {
    var elements = Array.prototype.slice.call(document.querySelectorAll(selector)).filter(isVisibleTarget);

    elements.forEach(function (el) {
      el.classList.add('ht-reveal');
      var direction = revealDirection(el);
      if (direction) el.classList.add(direction);

      var parent = el.closest('section, footer, header') || document.body;
      var siblings = Array.prototype.slice.call(parent.querySelectorAll('.ht-reveal'));
      var index = Math.max(0, siblings.indexOf(el));
      var delay = Math.min((index % 8) * 55, 385);
      el.style.setProperty('--ht-reveal-delay', delay + 'ms');
    });

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('ht-reveal-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ht-reveal-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px'
    });

    elements.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal, { once: true });
  } else {
    initReveal();
  }
})();
